<h2
  class="mr-heading"
  [class.is-h1]="block.level === 'h1'"
  [attr.data-align]="block.align || 'center'"
>
  {{ t(block.text) }}
</h2>
